export default "__VITE_ASSET__301f4aae__"